import { render, staticRenderFns } from "./KPIAssessmentSetting.vue?vue&type=template&id=30c1df36&scoped=true"
import script from "./KPIAssessmentSetting.vue?vue&type=script&lang=js"
export * from "./KPIAssessmentSetting.vue?vue&type=script&lang=js"
import style0 from "./KPIAssessmentSetting.vue?vue&type=style&index=0&id=30c1df36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c1df36",
  null
  
)

export default component.exports